<template>
  <div ref="list" class="main">
    <p v-if="!rentList.length" class="no-more">-- 没有更多了~ --</p>
    <get-more :on-load-more="onLoadMore" :enable-load-more="enableLoadMore" :load-more-text="loadMoreText">
      <div
        v-for="item of rentList"
        :key="item.publishId"
        class="store"
        @click="
          $router.push({
            path: '/storeInfo',
            query: {
              id: item.publishId,
            },
          })
        "
      >
        <van-image
          class="img"
          fit="cover"
          :src="item.showImg || require('@/imgs/place.png')"
        />
        <div v-if="item.publishStatus === '2'" class="up">推广</div>
        <div class="info">
          <h1>{{ item.title }}</h1>
          <h2>
            {{ item.contact || '匿名用户'
            }}<span>{{ item.phone ? handlePhone(item.phone) : '' }}</span>
          </h2>
          <!--<h3>今日成功匹配找店用户{{ item.pushCount }}人</h3>-->
          <h4>
            {{ item.acreage || '面议' }}㎡
            <span>{{ item.rent || '面议' }}</span>
            <p>元/月</p>
          </h4>
        </div>
      </div>
    </get-more>
  </div>
</template>

<script>
import LoadMore from '@/components/LoadMore'
import { getTransfer } from '@/api/api'
import { getLocation } from '@/utils/location'
import { handlePhone } from '@/utils/util'

export default {
  name: 'Store',
  components: {
    getMore: LoadMore // 注册mescroll组件
  },
  data() {
    return {
      loadMoreText: '加载中...',
      envId: parseInt(process.env.VUE_APP_SERVER_ID),
      isLook: false,
      cityName: this.$store.getters.cityName,
      rentList: [],
      page: 1,
      size: 10,
      enableLoadMore: true
    }
  },
  created() {
  },
  mounted() {
    if (!this.$store.getters.cityName) {
      this.getLocation()
    }
    this.getList()
  },
  methods: {
    handlePhone(phone) {
      return handlePhone(phone)
    },
    goToPublish() {
      this.$dialog({
        message: '请发布信息开通会员',
        confirmButtonText: '立即发布'
      }).then(() => {
        this.$router.push('/publish')
      })
    },
    getPhone(item) {
      const ids =
        JSON.parse(localStorage.getItem('lookIds')) !== null
          ? JSON.parse(localStorage.getItem('lookIds'))
          : []
      if (ids.length < 3) {
        this.tellThis(item, ids)
      } else {
        this.nextRouter(item, ids)
      }
    },

    tellThis(item, ids) {
      let arr = []
      if (!ids.includes(item.publishId)) {
        arr = [...ids, item.publishId]
        localStorage.setItem('lookIds', JSON.stringify(arr))
      }
      const a = document.createElement('a')
      a.href = `tel:${item.phone}`
      a.style.display = 'none'
      a.click()
    },

    async getLocation() {
      const res = await getLocation()
      const city = res.data.city
      await this.$store.dispatch('setCity', city)
      this.cityName = city
    },
    onLoadMore(done) {
      setTimeout(() => {
        if (!this.enableLoadMore) {
          return
        }
        this.page = this.page + 1
        this.getList()
        done()
      }, 200)
      // if (!this.enableLoadMore) {
      //   return
      // }
      // this.page = this.page + 1
      // this.getList()
      // done()
    },
    getList() {
      const { page, size = 10 } = this
      getTransfer({ page, size, cityName: this.$store.getters.cityName }).then((res) => {
        if (res.data.length === 0) {
          this.loadMoreText = '~ 到底了 ~'
          this.page = page - 1
        } else {
          const rentList = res.data
          this.rentList = this.rentList.concat(rentList)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  padding: 30px;
  display: flex;
  flex-direction: column;
  .no-more {
    line-height: 28px;
    white-space: nowrap;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 800;
    color: rgba(51, 51, 51, 1);
  }
  .store {
    margin-bottom: 30px;
    display: flex;
    flex-direction: row;
    position: relative;
    padding: 20px;
    width: 690px;
    height: 190px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 20px 0px rgba(179, 179, 179, 0.2);
    border-radius: 12px;
    .img {
      margin-right: 20px;
      width: 200px;
      height: 150px;
      border-radius: 6px;
      overflow: hidden;
    }
    .up {
      position: absolute;
      right: 0;
      top: 0;
      width: 75px;
      height: 36px;
      background: rgba(253, 106, 66, 1);
      border-radius: 0px 12px 0px 12px;
      line-height: 36px;
      text-align: center;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
    .info {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 4px 0;
      overflow: hidden;
      justify-content: space-between;
      h1 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 800;
        color: rgba(51, 51, 51, 1);
      }
      h2 {
        display: flex;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(153, 153, 153, 1);
        span {
          margin-left: 31px;
        }
      }
      h3 {
        padding: 0 3px;
        background: rgba(84, 123, 223, 1);
        border-radius: 4px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
      }
      h4 {
        display: flex;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(102, 102, 102, 1);
        span {
          margin: 0 10px 0 30px;
          line-height: 32px;
          font-size: 32px;
          font-family: PingFang SC;
          font-weight: 800;
          color: rgba(248, 66, 66, 1);
        }
        p {
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(248, 66, 66, 1);
        }
      }
    }
  }
}
</style>
